<template>
  <div class="wameed-dashboard-page-content">
    <page-header
        :title="$t('settings.work_days')"
        :paths="[{title:$t('settings.title'),link:'settings'}]"
    />

    <section class="wameed-dashboard-page-content_body">

      <div class="work-card">
        <div class="work-card__header">
          <div class="work-card__header_info">
            <div class="title">{{ $t('settings.work.general') }}</div>
            <div v-if="workDays.status===1">
              <span class="status open"> {{ $t('days.open') }} </span>
            </div>
            <div v-else>
              <span class="status close"> {{ $t('days.close') }} </span>
            </div>
          </div>
          <div class="switch">
            <WameedSwitch
                :checked="workDays.status ===1"
                @onChange="toggleGeneralStatus"
            />
          </div>
        </div>
      </div>


      <template v-if="workDays.days||true">

        <work-time-card
            title="sat"
            :day="workDays.days.sat"
            @onAdd="()=>showModal(1)"
            @onDelete="showDelete"
        />
        <work-time-card
            title="sun"
            :day="workDays.days.sun"
            @onAdd="()=>showModal(2)"
            @onDelete="showDelete"
        />
        <work-time-card
            title="mon"
            :day="workDays.days.mon"
            @onAdd="()=>showModal(3)"
            @onDelete="showDelete"
        />

        <work-time-card
            title="tue"
            :day="workDays.days.tue"
            @onAdd="()=>showModal(4)"
            @onDelete="showDelete"
        />
        <work-time-card
            title="wed"
            :day="workDays.days.wed"
            @onAdd="()=>showModal(5)"
            @onDelete="showDelete"
        />
        <work-time-card
            title="thur"
            :day="workDays.days.thur"
            @onAdd="()=>showModal(6)"
            @onDelete="showDelete"
        />

        <work-time-card
            title="fri"
            :day="workDays.days.fri"
            @onAdd="()=>showModal(7)"
            @onDelete="showDelete"
        />

      </template>


      <work-time-modal
          :visible="addModal"
          :day="modalDay"
          @close="addModal = false;modalDay=0"
      />

      <wameed-feedback-modal
          variant="danger"
          iconName="trash-icon"
          :visible="deleteModal"
          @close="deleteModal = false"
          @onClick="deleteAction"
          :title="$t('settings.work.modal.delete')"
          :subTitle="$t('settings.work.modal.delete_desc')"
          :btnTitle="$t('btn.delete')"
      />

    </section>
  </div>
</template>

<script>


import WorkTimeModal from "@/views/pages/settings/work_days/components/workTimeModal";
import PageHeader from '@/components/wameed/WameedPageHeader.vue';
import {WameedFeedbackModal,WameedSwitch} from 'wameed-ui/dist/wameed-ui.esm';
import {mapGetters} from "vuex";
import WorkTimeCard from "@/views/pages/settings/work_days/components/workTimeCard";

export default {
  components: {
    WameedFeedbackModal,
    WorkTimeModal,
    WorkTimeCard,
    WameedSwitch,
    PageHeader,
  },
  data() {
    return {
      addModal: false,
      deleteModal: false,
      modalDay: 0,
      deleteShiftId: 0,
    }
  },
  computed: {
    ...mapGetters({
      workDays: 'vendor/settings/workDays/getData',
    }),
  },

  methods: {
    toggleGeneralStatus() {
      let status = this.workDays.status === 1 ? 0 : 1;
      let form = {
        day: 'all',
        status: status,
      }
      this.$store.dispatch('vendor/settings/workDays/toggle', form);
    },
    showModal(day) {
      this.modalDay = day;
      this.addModal = true;
    },
    showDelete(id) {
      this.deleteShiftId = id;
      this.deleteModal = true;
    },
    deleteAction() {
      this.deleteModal = false
      this.$store.dispatch('vendor/settings/workDays/delete', this.deleteShiftId);
    }
  },
  mounted() {
    this.$store.dispatch('vendor/settings/workDays/get')
  }

};
</script>
